import { motion } from 'motion/react'
import { useMemo } from 'react'

import { PayrollConnectionPicker } from 'components/payroll/PayrollConnectionPicker'
import LoadingSpinnerCentered from 'components/reusable/LoadingSpinnerCentered'
import { useGetQuotingPayrollProviderConfigs } from 'utils/web_api'

interface PayrollConnectionProps {
  onSuccess: (censusId: string) => void;
}

export function PayrollConnection ({ onSuccess }: PayrollConnectionProps) {
  const { data, isLoading } = useGetQuotingPayrollProviderConfigs()

  const payrollProviders = data?.data || []
  const promotedProviders = useMemo(
    () =>
      payrollProviders.filter((provider) => provider.promoted_in_onboarding) ||
      [],
    [payrollProviders]
  )

  if (isLoading) {
    return <LoadingSpinnerCentered />
  }

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <PayrollConnectionPicker
        payrollProviders={payrollProviders}
        promotedPayrollProviders={promotedProviders}
        onSuccessCallback={() => {
          // TODO: This isn't going to work until we have a way to create a
          // census from the payroll connection.
          onSuccess('')
        }}
        // eslint-disable-next-line react/jsx-handler-names
        onSuccessUrl={window.location.href}
      />
    </motion.div>
  )
}
